import { useCurrentUser } from '@economic/react-app';
import React from 'react';
import { t } from '../../shared/components/l10n/l10n';
import useAppSettings from '../../shared/hooks/useAppSettings';
import useLocalStorage from '../../shared/hooks/useLocalStorage';
import track from '../../shared/util/utilities/mixpanel';
import { IconButtonWithBadge } from './SecondaryNavigation';

export function ESignatureIconButton(props) {
    const user = useCurrentUser();
    const [clickedOnESignatureButton, setClickedOnESignatureButton] = useLocalStorage<boolean>('clickedOnESignatureButton');
    const eSignatureNavbarIconVisibilitySettings = useAppSettings('isESignatureNavbarIconHidden');
    const [isESignatureNavbarIconHiddenLocalStorage] = useLocalStorage<boolean>('isESignatureNavbarIconHidden');
    // app settings do not work for admins so we store this information for them using localstorage.
    const hideESignatureIcon: boolean = user.isAdministrator
        ? isESignatureNavbarIconHiddenLocalStorage
        : eSignatureNavbarIconVisibilitySettings.data?.content?.isESignatureNavbarIconHidden ?? false;

    if (eSignatureNavbarIconVisibilitySettings.loading || hideESignatureIcon) {
        return null;
    }

    return (
        <IconButtonWithBadge
            {...props}
            icon="e-signature"
            aria-label="e-signature"
            onClick={() => {
                track('esignature.page', 'loaded', { from: 'topmenu' });
                setClickedOnESignatureButton(true);
            }}
            new={!clickedOnESignatureButton}
            tooltip={t`HEADER_TAB_E_SIGNATURE`}
        />
    );
}
